/**
 * SCRUM-92 (DS-008-9) — end-ownership.schema.ts
 *
 * Zod schema for PATCH /organizations/:slug/properties/:propertyId/ownership/:ownershipId/end
 * request body (endpoint #2).
 */
import { z } from 'zod';
export const END_OWNERSHIP_REASONS = [
    'sold',
    'transferred',
    'property_archived',
    'owner_deactivated',
    'expired',
];
export const endOwnershipSchema = z.object({
    endedReason: z.enum(END_OWNERSHIP_REASONS),
    /** ISO 8601 datetime. Defaults to now at the UC layer when omitted. */
    endedAt: z.string().datetime().optional(),
});
//# sourceMappingURL=end-ownership.schema.js.map